export function toArray(value) {
  if (!value) return [];
  if (Array.isArray(value)) return value;
  if (typeof value === "string") {
    try {
      const parsed = JSON.parse(value);
      return Array.isArray(parsed) ? parsed : parsed ? [parsed] : [];
    } catch {
      return [];
    }
  }
  if (typeof value === "object") {
    if (Array.isArray(value.data)) return value.data;
    if (Array.isArray(value.items)) return value.items;
    if (Array.isArray(value.list)) return value.list;
  }
  return [value];
}

export function mapBanners(value, { sort = false } = {}) {
  const rows = toArray(value)
    .map((item) => {
      const imageSrc = item?.feature_image || "";
      const alt = item?.name || "Banner";
      const cta = typeof item?.cta === "string" ? item.cta.trim() : "";
      const priority = Number(item?.priority ?? 0);
      if (!imageSrc) return null;
      return {
        id: `${imageSrc}-${alt}`,
        imageSrc,
        alt,
        cta,
        priority: Number.isFinite(priority) ? priority : 0,
      };
    })
    .filter(Boolean);
  if (!sort) return rows;
  return [...rows].sort((a, b) => b.priority - a.priority);
}

export function resolveGmncBannerImage(value) {
  if (!value) return "";
  if (typeof value === "string") return value.trim();
  if (typeof value === "object") {
    const src = value.url || value.src || value.feature_image || value.path || "";
    return typeof src === "string" ? src.trim() : "";
  }
  return "";
}

export function resolveGmncBannerLink(value) {
  return typeof value === "string" ? value.trim() : "";
}
